import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import { membershipData } from '../../data/mock';

const MEMBERSHIP_EMAIL = 'members@anchoralgarve.com';

const Membership = () => {
  const mailtoHref = `mailto:${MEMBERSHIP_EMAIL}?subject=${encodeURIComponent(
    'Membership Request — ANCHOR'
  )}&body=${encodeURIComponent(
    'Full name:\nCompany / Profession:\nIntended use:\nPhone:\nFounder member reference:\n'
  )}`;

  return (
    <section id="membership" className="section-padding bg-[#1E2E2A]">
      <div className="container-custom">
        <div className="max-w-2xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl md:text-4xl font-normal text-white mb-6 tracking-wider">
              {membershipData.title}
            </h2>
            <p className="text-lg text-white/60 leading-relaxed mb-4">
              {membershipData.copy}
            </p>
            <p className="text-sm text-white/40">
              {membershipData.disclaimer}
            </p>
          </div>

          {/* Direct email CTA */}
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-white/10 text-center">
            <h3 className="font-display text-xl text-white mb-4 tracking-wide">
              By Invitation Only
            </h3>
            <p className="text-white/60 leading-relaxed mb-8">
              ANCHOR is a private members&rsquo; club, opened through invitation and personal
              introduction. If you feel ANCHOR is the right home for your work, we welcome
              a quiet conversation — every enquiry is considered with discretion.
            </p>

            <Button
              asChild
              className="bg-[#3E6259] hover:bg-[#5C7A6E] text-white font-medium h-12 px-8 rounded-full transition-all duration-300 hover:shadow-lg group tracking-wide"
            >
              <a href={mailtoHref} data-testid="membership-email-cta">
                <span className="flex items-center justify-center">
                  Enquire Privately
                  <ArrowRight className="ml-2 w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </a>
            </Button>

            <p className="text-sm text-white/40 mt-6">
              To introduce yourself, write to us at{' '}
              <a
                href={`mailto:${MEMBERSHIP_EMAIL}`}
                className="text-[#5C7A6E] hover:text-white transition-colors duration-300 underline underline-offset-4"
                data-testid="membership-email-link"
              >
                {MEMBERSHIP_EMAIL}
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Membership;
